import { Outlet, createFileRoute } from "@tanstack/react-router";

import { STATIC_LABELS } from "@/lib/nav-registry";

// 注: ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
export const Route = createFileRoute("/_authenticated/member/companies")({
  staticData: {
    crumb: { label: STATIC_LABELS.memberCompanies, to: "/member/companies" },
  },
  component: () => <Outlet />,
});
